module.exports = __webpack_public_path__ + "img/2.ced21980.png";